const _ = require('lodash');
const metricSettings = require('relevant-shared/reportData/metricSettings');
const { hb: { CALCULATED_SUMS } } = require('../reportData/constants');

const DefaultPerfMethod = 'adUnitEcpm';
const AvailablePerfMethods = ['adUnitEcpm', 'fillRate', 'bidRatePerc', 'winRatePerc', 'timedOutPerc', 'avgResponseMs'];

const getPerformanceDisabledBidders = (configData, siteIds, biddersBySspId, yesterdaysTrimmedHbReport) => {
	const disabledStates = {};
	const bySspSettings = _.pickBy(configData.rlvBySsp, 'perfValue');
	if (_.isEmpty(bySspSettings)) {
		return {};
	}
	const reportDatas = _.filter(siteIds.map((id) => yesterdaysTrimmedHbReport?.[id]));
	const reportByBidder = reportDatas.length === 1
		? reportDatas[0]
		: _.mergeWith({}, ...reportDatas, (dst, src) => (_.isNumber(dst) ? dst + src : undefined));
	if (_.isEmpty(reportByBidder)) {
		return {};
	}
	_.forEach(bySspSettings, ({ perfMethod = DefaultPerfMethod, perfValue, byCountry }, sspId) => {
		biddersBySspId[sspId]?.forEach((bidder) => {
			const reportByCountry = bidder && reportByBidder[bidder];
			const { isNegativeIfIncrease } = metricSettings.hb[perfMethod] || {};
			const { fn: sumFn, requires } = CALCULATED_SUMS[perfMethod] ?? {};
			if (!perfMethod || !perfValue || !reportByCountry || !sumFn
				|| requires.some((m) => !(m in Object.values(reportByCountry)[0])) // don't disable if the report doesn't contain necessary data (for example if we just added a new metric dependency)
			) {
				return;
			}
			let isLowPerformance = (data) => sumFn(data) < perfValue;
			if (isNegativeIfIncrease) {
				isLowPerformance = (data) => sumFn(data) > perfValue;
			}
			if (byCountry) {
				const countrySettings = {};
				for (const [countryCode, metrics] of Object.entries(reportByCountry)) {
					let countryKey;
					if (countryCode === 'other') {
						countryKey = 'other';
					} else if (countryCode === '0') {
						countryKey = '[Unknown]';
					} else {
						const code = Number(countryCode);
						// eslint-disable-next-line no-bitwise
						countryKey = String.fromCodePoint(code & 0xFF, code >> 8);
					}
					countrySettings[countryKey] = isLowPerformance(metrics);
				}
				const bools = Object.values(countrySettings);
				const trues = _.filter(bools);
				if (trues.length) { // Else, if no country is disabled => no need to add any disable-setting
					disabledStates[bidder] = trues.length === bools.length
						? { performanceDisabled: true } // All countries should be disabled => do it in one go
						: { performanceDisabledByCountry: countrySettings };
				}
			} else {
				const sum = _.reduce(_.values(reportByCountry), (acc, obj) => _.mergeWith(acc, obj, (a, b) => a + b));
				if (isLowPerformance(sum)) {
					disabledStates[bidder] = { performanceDisabled: true };
				}
			}
		});
	});
	return disabledStates;
};

module.exports = {
	getPerformanceDisabledBidders,
	DefaultPerfMethod,
	AvailablePerfMethods,
};
